export class AuthPermission {
  resId = "";
  optIds: string[] = [];
}

export class AuthRole {
  id?: string;
  name = "";
  permissions: AuthPermission[] = [];
  sortOrder = 0;
}
